// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__2VtNS","modalForm":"UpgradeEpcsModal_modalForm__2FcfJ","modalFooter":"UpgradeEpcsModal_modalFooter__raWHW"};